import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  style: {
    "margin": "16px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_loading = _resolveComponent("van-loading");
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_image = _resolveComponent("van-image");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_form = _resolveComponent("van-form");
  const _component_PageNavLayoutCpt = _resolveComponent("PageNavLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavLayoutCpt, null, {
    default: _withCtx(() => [!$data.isShowPage ? (_openBlock(), _createBlock(_component_van_loading, {
      key: 0,
      style: {
        "text-align": "center",
        "margin-top": "30vh"
      },
      color: "#1989fa",
      size: "36"
    })) : (_openBlock(), _createBlock(_component_van_form, {
      key: 1,
      onSubmit: $options.onSubmit
    }, {
      default: _withCtx(() => [_createVNode(_component_van_field, {
        modelValue: $data.userCode,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.userCode = $event),
        required: "",
        name: "userCode",
        label: "用户名",
        placeholder: "用户名",
        rules: [{
          required: true,
          message: '请填写用户名'
        }]
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        modelValue: $data.password,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.password = $event),
        required: "",
        type: "password",
        name: "密码",
        label: "密码",
        placeholder: "密码",
        rules: [{
          required: true,
          message: '请填写密码'
        }]
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        modelValue: $data.validateCode,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.validateCode = $event),
        required: "",
        name: "validateCode",
        label: "验证码",
        placeholder: "验证码",
        rules: [{
          required: true,
          message: '请填写验证码'
        }]
      }, {
        button: _withCtx(() => [_createVNode(_component_van_image, {
          height: "24",
          width: "72",
          src: _ctx.codeCheckImg,
          disabled: _ctx.isCodeLoading,
          onClick: _ctx.onFreshCodeClick
        }, null, 8, ["src", "disabled", "onClick"])]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_van_button, {
        round: "",
        block: "",
        loading: $data.logging,
        type: "primary",
        "native-type": "submit"
      }, {
        default: _withCtx(() => [_createTextVNode(" 提交 ")]),
        _: 1
      }, 8, ["loading"])])]),
      _: 1
    }, 8, ["onSubmit"]))]),
    _: 1
  });
}